export default function (url) {
  // const qs = url.substring(url.lastIndexOf('?'))
  const qs = (new URL(url)).search
  const searchParams = new URLSearchParams(qs)
  const paramsObj = Object.fromEntries(searchParams)
  return paramsObj
}
